(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["suunto-product-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('suunto-product-videos')) {
    customElements.define('suunto-product-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.abort = new AbortController();
        this.on = (node, name, fn) => node.addEventListener(name, fn, {signal:this.abort.signal});
        this.templates = [...this.querySelectorAll('[data-sv-video]')];
        this.cards = [...this.querySelectorAll('[data-sv-open]')];
        this.dialog = this.querySelector('.sv-dialog');
        this.mini = this.querySelector('.sv-mini');
        this.stage = this.dialog.querySelector('.sv-stage');
        this.track = this.querySelector('.sv-track');
        this.toggle = this.mini.querySelector('[data-sv-toggle]');
        this.index = -1;
        this.media = matchMedia('(max-width:767px)');
        const scope = this.closest('.xo-product-info-content');
        const warranty = scope?.querySelector('.suunto-warranty-wrap');
        if (warranty) {
          this.anchor = document.createElement('span');
          this.anchor.hidden = true;
          warranty.before(this.anchor);
          const place = () => {
            this.relocating = true;
            if (this.media.matches) warranty.before(this); else warranty.after(this);
            this.relocating = false;
          };
          this.on(this.media,'change',place);
          place();
        }
        document.body.append(this.dialog, this.mini);
        this.cards.forEach((card,index) => this.on(card,'click',() => this.open(index)));
        this.querySelectorAll('[data-sv-scroll]').forEach(button => this.on(button,'click',() => this.track.scrollBy({left:Number(button.dataset.svScroll)*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})));
        this.on(this.track,'scroll',() => this.updateArrows());
        this.resize = new ResizeObserver(() => this.updateArrows());
        this.resize.observe(this.track);
        this.on(this.dialog.querySelector('[data-sv-minimize]'),'click',() => this.minimize());
        this.on(this.dialog,'cancel',event => {event.preventDefault();this.minimize();});
        this.on(this.dialog,'click',event => {if(event.target===this.dialog)this.minimize();});
        this.on(this.dialog.querySelector('[data-sv-prev]'),'click',() => this.open((this.index+this.templates.length-1)%this.templates.length));
        this.on(this.dialog.querySelector('[data-sv-next]'),'click',() => this.open((this.index+1)%this.templates.length));
        this.on(this.mini.querySelector('[data-sv-close]'),'click',() => this.stop());
        this.on(this.mini.querySelector('[data-sv-expand]'),'click',() => this.open(this.index));
        this.on(this.toggle,'click',() => {if(this.video?.paused)this.play();else this.video?.pause();});
        this.on(document,'suunto-video-active',event => {if(event.detail!==this)this.stop();});
        this.on(window,'pagehide',() => this.stop());
        this.dialog.querySelector('[data-sv-prev]').hidden = this.templates.length<2;
        this.dialog.querySelector('[data-sv-next]').hidden = this.templates.length<2;
        this.updateArrows();
      }
      updateArrows() {
        const buttons = this.querySelectorAll('[data-sv-scroll]');
        if(buttons.length!==2)return;
        buttons[0].disabled = this.track.scrollLeft<=2;
        buttons[1].disabled = this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
      }
      play() {
        this.video?.play().catch(() => {this.updateToggle();});
      }
      updateToggle() {
        const paused = !this.video || this.video.paused;
        this.toggle.textContent = paused?'▶':'Ⅱ';
        this.toggle.setAttribute('aria-label',paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel);
      }
      open(index) {
        if(index<0 || !this.templates[index])return;
        document.dispatchEvent(new CustomEvent('suunto-video-active',{detail:this}));
        const resume = this.index!==index || !this.video || !this.video.paused || this.video.ended;
        if(this.index!==index || !this.clip) {
          this.video?.pause();
          this.clip?.remove();
          this.clip = this.templates[index].content.firstElementChild.cloneNode(true);
          this.video = this.clip.querySelector('video');
          this.index = index;
          this.on(this.video,'play',() => this.updateToggle());
          this.on(this.video,'pause',() => this.updateToggle());
          this.on(this.video,'error',() => {this.clip.querySelector('.sv-error').hidden=false;});
          this.on(this.clip.querySelector('[data-sv-retry]'),'click',() => {this.clip.querySelector('.sv-error').hidden=true;this.video.load();this.play();});
        }
        this.stage.append(this.clip);
        this.video.controls = true;
        this.mini.hidden = true;
        if(!this.dialog.open) {
          this.focusBefore = document.activeElement;
          this.oldOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow='hidden';
          this.dialog.showModal();
        }
        if(resume)this.play();
        this.dialog.querySelector('[data-sv-minimize]').focus();
      }
      minimize() {
        if(!this.clip)return;
        const playing = !this.video.paused;
        this.closeDialog();
        this.mini.querySelector('.sv-mini-stage').append(this.clip);
        this.video.controls=false;
        this.mini.hidden=false;
        if(playing)this.play();
        this.updateToggle();
        this.cards[this.index]?.focus({preventScroll:true});
      }
      closeDialog() {
        if(this.dialog.open) {
          this.dialog.close();
          document.documentElement.style.overflow=this.oldOverflow??'';
        }
      }
      stop() {
        this.video?.pause();
        this.closeDialog();
        this.mini.hidden=true;
        this.clip?.remove();
        this.clip=null;
        this.video=null;
        this.index=-1;
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if(this.isConnected || this.relocating)return;
          this.stop();
          this.abort?.abort();
          this.resize?.disconnect();
          this.dialog?.remove();
          this.mini?.remove();
          this.ready=false;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
